import React from 'react';
import FooterParagraph from './FooterParagraph';
import BillingProblemsMessage from '../BillingProblemsMessage';
import classes from './Footer.module.scss';

const Footer = () => (
  <footer className={classes.footer}>
    <div className={classes.footerContentContainer}>
      <div className={classes.footerTextContent}>
        <FooterParagraph>
          <BillingProblemsMessage />
        </FooterParagraph>
      </div>
    </div>
    <div className={classes.footerMainContentContainer} />
    <div className={classes.footerContentContainer}>
      <div className={classes.footerTextContent}>
        <FooterParagraph>Copyright (c) 2020 Epicland</FooterParagraph>
      </div>
    </div>
  </footer>
);

export default Footer;
